import { useLanguageContext } from '../../../contexts/LanguageContext';
import { dateTimeUtils } from '../../../utils/DateTimeUtils';

export const useDatePickerConnector = () => {
  return {
    dateTimeUtils: dateTimeUtils(),
    languageContext: useLanguageContext(),
  };
};
